// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__32tWn","spin":"LoadingSpinner_spin__3FVoi","fadeIn":"LoadingSpinner_fadeIn__1oEqC"};